import CloseIcon from '@mui/icons-material/Close';
import { DialogContent, DialogTitle, IconButton } from '@mui/material';
import { bool, func, oneOf } from 'prop-types';
import React from 'react';
import { SWDialog } from '../mui/Dialog';
import spacingStyles from '../../styles/spacing-styles.module.css';
import textStyles from '../../styles/text-styles.module.css';
import { FormattedMessage } from '../../util/reactIntl';

const feeDialogConfig = {
  service: {
    titleId: 'ServiceFeeDialog.title',
    headerId: 'ServiceFeeDialog.header',
    descriptionId: 'ServiceFeeDialog.description',
    defaultCommissionPercentage: '2.5',
  },
  transaction: {
    titleId: 'TransactionFeeDialog.title',
    headerId: 'TransactionFeeDialog.header',
    descriptionId: 'TransactionFeeDialog.description',
    defaultCommissionPercentage: '3.5',
  },
};

const FeeInfoDialog = ({ isOpen, onClose, type, commissionPercentage }) => {
  const { titleId, headerId, descriptionId, defaultCommissionPercentage } = feeDialogConfig[type];
  const actualCommissionPercentage = commissionPercentage || defaultCommissionPercentage;

  return (
    <SWDialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: { maxWidth: '500px !important' },
      }}
      scroll="paper"
    >
      <DialogTitle sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
        <FormattedMessage id={titleId} />
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'white',
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent tabIndex={-1} sx={{ paddingBlock: '32px !important' }}>
        <div className={`${textStyles.bodyTextB3} ${spacingStyles.mb8}`}>
          <FormattedMessage
            id={headerId}
            values={{ commissionPercentage: actualCommissionPercentage }}
          />
        </div>
        <div className={textStyles.bodyTextB3}>
          <FormattedMessage id={descriptionId} />
        </div>
      </DialogContent>
    </SWDialog>
  );
};

FeeInfoDialog.defaultProps = {
  isOpen: false,
  type: 'service',
};

FeeInfoDialog.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
  type: oneOf(Object.keys(feeDialogConfig)),
};

export default FeeInfoDialog;
